import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import moment from 'moment';
import { UserInfoType } from '../../../types/loginTypes';
import {
  getUserFromLS,
  setUserToLS
} from '../../../helpers/localstorage-helper';
import { changeUserInfo } from '../../../slices/auth-slice';
import { KYC_DOCUMENT_DETAILS } from '../../../routes/routes';
import { ErrorToast } from '../../../components';

interface AddKycPersonalDetailsType {
  day: string;
  month: string;
  year: string;
  country: string;
  name: string;
  surname: string;
  countryCode: string;
  history: any;
}

export const addKycPersonalDetails = createAsyncThunk(
  'kyc/addKycPersonalDetails',
  async (
    {
      day,
      month,
      year,
      country,
      name,
      surname,
      countryCode,
      history
    }: AddKycPersonalDetailsType,
    { rejectWithValue, dispatch }
  ) => {
    try {
      let newDate = moment(`'${year}-${month}-${day}'`, 'YYYY-MM-DD');

      const date = newDate.format();

      const convertedDate = moment().format(date);

      const { data } = await axios.post(`/user/kyc/personal-details`, {
        dateOfBirth: convertedDate,
        country,
        name,
        surname,
        countryCode
      });

      const kycStatus = data.data.kycStatus;

      const currentUser: UserInfoType = getUserFromLS();

      const user = { ...currentUser, kycStatus };

      dispatch(changeUserInfo(user));

      setUserToLS(user);

      history.push(KYC_DOCUMENT_DETAILS);

      return user;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
